import "./style.css";
import Fundo from '../../assets/Fundo.png';
import { useEffect, useState } from "react";
import React from 'react';
import api from '../../services/api.js';
import { useNavigate } from "react-router-dom";
import { useAppContext } from '../../context/AppContext.js';
import { IMaskInput } from "react-imask";


function VerificaEmpresa() {

    const navigate = useNavigate();
    const [cnpj, setCNPJ] = useState('');
    const [sucesso, setsucesso] = useState('');
    const [loading, setloading] = useState(false);
    const { setCodAssinante, setSelectedCompany } = useAppContext();

    function ProcessaLogin(e) {
        e.preventDefault();
        setsucesso('');
        setloading(true);
        api.post('/v1/verificaempresa', {
            cnpj,
        }).then(response => {
            setCodAssinante(response.data.codassinante);
            setSelectedCompany(response.data.codempresa);

            localStorage.setItem("CNPJ", cnpj);

            setsucesso('S');
            navigate('/login');
        }).catch(() => {
            setsucesso('N');
            setloading(false);
        })
    }

    useEffect(
        function () {
            setCNPJ(localStorage.getItem("CNPJ"))
        },
        []
    );

    return <div className="container">
        <div className="logina">
            <img className="background-login" src={Fundo} alt="Fundo" />
            <form className="form-login">
                <h3 className="mb-4">Localizando a Empresa</h3>

                <div className="form-floating">
                    <IMaskInput
                        mask={"00.000.000/0000-00"}
                        radix="."
                        id="cnpj"
                        className="form-control"
                        placeholder="CNPJ"
                        value={cnpj}
                        onAccept={(value) => setCNPJ(value)}
                    />
                    <label htmlFor="cnpj">CNPJ</label>
                </div>

                <button onClick={ProcessaLogin} className="w-100 btn btn-lg btn-success" disabled={loading}>
                    {loading ? <div>
                        <span className="spinner-border spinner-border-sm text-light" role="status"></span>
                        <span className="ms-2">Autenticando...</span>
                    </div> : <span className="ms-2">Acessar</span>}
                </button>
                {sucesso === 'N' ? <div className="alert alert-danger mt-2" role="alert">CNPJ não localizado...</div> : null}
            </form>
        </div>
    </div>
}

export default VerificaEmpresa;